import { FieldErrors, Resolver } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { FieldError } from 'react-hook-form/dist/types/errors'
import HouseConsignmentSchema, { HouseConsignmentFormValues } from 'features/declaration/house-consignment/models/schema'
import setFieldErrorByPath from 'shared/rhf/setFieldErrorByPath'
import HouseConsignmentResolverContext from './HouseConsignmentResolverContext'
import validaHouseConsignmentFormFieldStates from '../../form/validations/fieldStates/houseConsignment'

const houseConsignmentFormResolver: Resolver<HouseConsignmentFormValues, HouseConsignmentResolverContext> = async (
  values,
  context,
  options,
) => {
  const baseZodResolver = zodResolver(HouseConsignmentSchema)
  const zodResult = await baseZodResolver(values, context, options)

  const fieldErrors = validaHouseConsignmentFormFieldStates(values, {
    ...(context?.validationContextRef?.current ?? {
      specificCircumstanceIndicator: '',
      security: '0',
      isEns: false,
      additionalDeclarationType: 'A',
      country: null,
      isDraft: true,
    }),
    serverValidationResult: context?.serverValidationResult,
  })

  const errors: FieldErrors<HouseConsignmentFormValues> = { ...zodResult.errors }

  for (const err of fieldErrors) {
    const codeSuffix = err.code ? `:${err.code}` : ''
    setFieldErrorByPath(errors, err.path, {
      type: `ncts${codeSuffix}`,
      message: err.message,
    } as FieldError)
  }

  const hasErrors = Object.keys(errors).length > 0

  return {
    values: hasErrors ? {} : zodResult.values,
    errors,
  }
}

export default houseConsignmentFormResolver
